/**
 * Business facts (name / address / phone / email). They feed the JSON-LD business node and must
 * match the footer, the contact page and the Google Business Profile exactly. Every value is taken
 * from the existing site copy (footer, contact page, program page CTAs, chatbot); nothing is guessed.
 *
 * Not on the site, so deliberately absent (questions for the client): legal name, opening hours,
 * geo pin, real social profile URLs. MedicalOrganization is an Organization (not a Place), so it
 * carries no geo or openingHoursSpecification anyway.
 */
export const business = {
  brandName: 'Chronicity Health',
  /** Footer tagline. */
  description:
    'Comprehensive chronic care management with integrated healthcare solutions for superior patient outcomes.',
  streetAddress: '29436 Ford Rd.',
  addressLocality: 'Garden City',
  addressRegion: 'MI',
  postalCode: '48135',
  addressCountry: 'US',
  phoneDisplay: '(844) 422-6633',
  phoneE164: '+18444226633',
  email: 'info@setupccm.com',
  /** Real, verified profile URLs only (the footer icons link to generic network home pages). */
  sameAs: [] as string[],
} as const;
